/**
 * @generated SignedSource<<10ee7dda59e5ab70494eb55ff2ff6c49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleContentVariant_viewer$data = {
  readonly onSaleVerticals: ReadonlyArray<{
    readonly category: string | null;
    readonly displayName: string | null;
    readonly linkData: {
      readonly path: string | null;
    };
  } | null> | null;
  readonly " $fragmentType": "HpSharedFeaturedModuleContentVariant_viewer";
};
export type HpSharedFeaturedModuleContentVariant_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModuleContentVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContentVariant_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleContentVariant_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OnSaleVertical",
      "kind": "LinkedField",
      "name": "onSaleVerticals",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e16019765c074545d27f82035a631bd0";

export default node;
